import Vue from "vue";
import Vuex from "vuex";

import {
    CLIENT_ID,
    Tenant,
    Redirect_Uri,
} from "@/config/constants";

// Helpers
import { avActions } from "@/actions";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalToken } from "@/utils/helpers";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        accessToken: sessionStorage.getItem("accessToken")
            ? sessionStorage.getItem("accessToken").replace(/['"]+/g, "")
            : "",
        avAccessToken: sessionStorage.getItem("avAccessToken")
            ? sessionStorage.getItem("avAccessToken").replace(/['"]+/g, "")
            : "",
        msalConfig: {
            auth: {
                clientId: CLIENT_ID,
                authority: `https://login.microsoftonline.com/${Tenant}/`,
                navigateToLoginRequestUrl: true,
                redirectUri: Redirect_Uri,
                postLogoutRedirectUri: Redirect_Uri,
            },
            cache: {
                cacheLocation: "sessionStorage",
            },
        },
        tokenConfiguration: {},
        isAuth: false,
        username: {
            userEmail: ""
        },
        isUserAdmin: false,
        isUserApprover: false,
        isUserViewer: true,
    },
    actions: {
        async userActivity({ commit }) {
            const accessToken = localStorage.getItem("accessToken");
            if (accessToken) {
                const idToken = await getMsalToken(this, 'av_msal_token');
                const payload = await avActions.getUserActivity(idToken);
                await AxiosFetchForMsal(payload)
                    .then((response) => {
                        commit("setActivityTasks", response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },
        setUserDataAction({ commit }, token) {
            commit("setUserData", token);
        },
        setAccessTokenAction({ commit }, token) {
            commit("setAccessToken", token);
        },
        setAVAccessTokenAction({ commit }, token) {
            commit("setAVAccessToken", token);
        },

    },
    mutations: {
        getAccessToken(state, value) {
            state.accessToken = value;
        },
        setAccessToken(state, token) {
            state.tokenConfiguration = token;
            state.accessToken = token.access_token;
        },
        setAVAccessToken(state, token) {
            state.avAccessToken = token.access_token;
        },
        setUserData(state, userData) {
            state.username = userData;
        },
        setActivityTasks(state, value) {
            state.activityTasks = value;
        },
        setUserEmail(state, payload) {
            this.state.username.userEmail = payload;
        },
        isUserAuthorized(state, payload) {
            state.isAuth = payload;
        },
        setUserRoleStatus(state, payload) {
            state.isUserAdmin = payload.isAdmin;
            state.isUserApprover = payload.isApprover;
            state.isUserViewer = (payload.isApprover || payload.isAdmin) ? false : true ;
        },
    },
    getters: {
        getTokenData(state) {
            return state.tokenConfiguration;
        },
        username(state) {
            return state.username;
        },
        accessToken(state) {
            return state.accessToken;
        },
        avAccessToken(state) {
            return state.avAccessToken;
        },
        getUserData(state) {
            return state.username;
        },
    },
});
